import { Box, IconButton, Tooltip, Chip } from "@mui/joy";
import { Info as InfoIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { isDefaultPlatformRole } from "../../../../interfaces";

/**
 * Info cell renderer - navigates to edit/view role page
 */
export function Info(props: any) {
    const navigate = useNavigate();
    const { value, data } = props;
    const isDefault = data ? isDefaultPlatformRole(data) : false;

    const handleClick = () => {
        navigate(`/admin/roles/edit/${value}`);
    };

    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100%"}>
            <Tooltip title={isDefault ? "View details" : "Edit role"} placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="primary"
                    onClick={handleClick}
                    sx={{ "--IconButton-size": "32px" }}
                >
                    <InfoIcon size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

export function ScopeCellRenderer(props: any) {
    const isDefault = props.data ? isDefaultPlatformRole(props.data) : false;

    return (
        <Box display="flex" alignItems="center" height="100%">
            <Chip size="sm" variant="soft" color={isDefault ? "neutral" : "primary"}>
                {isDefault ? "Platform" : "Organization"}
            </Chip>
        </Box>
    );
}
